if (!customElements.get("auth-modal")) {
  customElements.define(
    "auth-modal",
    class LoginModal extends HTMLElement {
      modalElement;
      signupModalElement;
      recoveryModalElement;
      constructor() {
        super();
        this.modalElement = null;
        this.signupModalElement = null;
        this.recoveryModalElement = null;
        this.openModal = this.openModal.bind(this);
        this.openSignupModal = this.openSignupModal.bind(this);
        this.openRecoveryModal = this.openRecoveryModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
      }
      connectedCallback() {
        document.addEventListener("DOMContentLoaded", () => {
          this.modalElement = document.getElementById("login-modal");
          this.signupModalElement = document.getElementById("signup-modal");
          this.recoveryModalElement = document.getElementById("recovery-modal");
          if (this.modalElement || this.signupModalElement || this.recoveryModalElement) {
            this.attachEventListeners();
          } else {
            console.error("One or more modal elements not found!");
          }
        });
      }
      attachEventListeners() {
        const openLoginButtons = document.querySelectorAll(".open-login-modal");
        openLoginButtons.forEach((button) => {
          button.addEventListener("click", this.openModal);
        });
        const openSignupButtons = document.querySelectorAll(".open-signup");
        openSignupButtons.forEach((button) => {
          button.addEventListener("click", this.openSignupModal);
        });
        const openRecoveryButtons = document.querySelectorAll(".open-reset");
        openRecoveryButtons.forEach((button) => {
          button.addEventListener("click", this.openRecoveryModal);
        });
        const closeLoginButtons = this.modalElement?.querySelectorAll(".close-login-modal");
        closeLoginButtons?.forEach((button) => {
          button.addEventListener("click", this.closeModal);
        });
        const closeSignupButtons = this.signupModalElement?.querySelectorAll(".close-login-modal");
        closeSignupButtons?.forEach((button) => {
          button.addEventListener("click", this.closeModal);
        });
        const closeRecoveryButtons = this.recoveryModalElement?.querySelectorAll(".close-login-modal");
        closeRecoveryButtons?.forEach((button) => {
          button.addEventListener("click", this.closeModal);
        });
        this.modalElement?.addEventListener("click", (event) => {
          if (event.target === this.modalElement) {
            this.closeModal();
          }
        });
        this.signupModalElement?.addEventListener("click", (event) => {
          if (event.target === this.signupModalElement) {
            this.closeModal();
          }
        });
        this.recoveryModalElement?.addEventListener("click", (event) => {
          if (event.target === this.recoveryModalElement) {
            this.closeModal();
          }
        });
      }
      openModal() {
        if (this.modalElement) {
          this.hideAllModals();
          this.modalElement.classList.remove("hidden");
        } else {
          console.error("Login modal element not found.");
        }
      }
      openSignupModal() {
        if (this.signupModalElement) {
          this.hideAllModals();
          this.signupModalElement.classList.remove("hidden");
        } else {
          console.error("Sign-up modal element not found.");
        }
      }
      openRecoveryModal() {
        if (this.recoveryModalElement) {
          this.hideAllModals();
          this.recoveryModalElement.classList.remove("hidden");
        } else {
          console.error("Recovery modal element not found.");
        }
      }
      hideAllModals() {
        if (this.modalElement) {
          this.modalElement.classList.add("hidden");
        }
        if (this.signupModalElement) {
          this.signupModalElement.classList.add("hidden");
        }
        if (this.recoveryModalElement) {
          this.recoveryModalElement.classList.add("hidden");
        }
      }
      closeModal() {
        this.hideAllModals();
      }
    }
  );
}
document.addEventListener("DOMContentLoaded", () => {
  if (!document.querySelector("auth-modal")) {
    const authModalElement = document.createElement("auth-modal");
    document.body.appendChild(authModalElement);
  }
});
